import React from 'react';

const Settings = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-4">Settings</h1>
      <p>Configure your shop preferences and account settings here.</p>
    </div>
  );
};

export default Settings;
